Updates an existing webhook subscription's signing configuration.

This modifies fields related to the signature of an existing webhook subscription.
Changes may take up to half an hour to take effect.
